// utils
import axios from './axios';

// ----------------------------------------------------------------------

export const handleLanguageChange = (lang: string) => {
  axios.defaults.headers.common['accept-language'] = lang || 'tr';
};
